import { createAsyncActionType } from './index';

export const NOTIFICATION_GET = createAsyncActionType('notification', 'NOTIFICATION_GET');
export const NOTIFICATION_READ = createAsyncActionType('notification', 'NOTIFICATION_READ');
